"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_1 = __importDefault(require("cookie"));
exports.SESSION_STORAGE_KEY = 'responseIds';
function getLastResponseId() {
    try {
        var sessionIds = sessionStorage.getItem(exports.SESSION_STORAGE_KEY);
        if (sessionIds) {
            var responseIds = JSON.parse(sessionIds) || [];
            return responseIds[responseIds.length - 2] || '';
        }
    }
    catch (_) { }
    return '';
}
function addLastSearchResponseId(responseId) {
    try {
        var existing = sessionStorage.getItem(exports.SESSION_STORAGE_KEY);
        if (existing) {
            var searchResponseIds = JSON.parse(existing);
            if (searchResponseIds[searchResponseIds.length - 1] !== responseId) {
                window.sessionStorage.setItem(exports.SESSION_STORAGE_KEY, JSON.stringify(searchResponseIds.concat([responseId])));
            }
        }
        else {
            sessionStorage.setItem(exports.SESSION_STORAGE_KEY, JSON.stringify([responseId]));
        }
    }
    catch (_) { }
}
exports.addLastSearchResponseId = addLastSearchResponseId;
// the session is the request payload of a pingback request
exports.createSession = function (event_type, actions, responseId, loggedInUserId) {
    if (responseId === void 0) { responseId = ''; }
    if (loggedInUserId === void 0) { loggedInUserId = ''; }
    return ({
        user: {
            user_id: cookie_1.default.parse(document.cookie).giphy_pbid,
            logged_in_user_id: loggedInUserId || '',
        },
        events: [
            {
                event_type: event_type,
                referrer: document ? document.referrer : '',
                actions: actions,
                response_id: responseId,
                prior_response_id: getLastResponseId(),
            },
        ],
    });
};
//# sourceMappingURL=session.js.map